import React from 'react';
import { IconClose } from '@noths/polaris-client-ribbons-design-system';

import type { Facet, FacetOption } from 'src/redux/productsQuery/types/Facet';
import type { ChangedFacetDetails } from '../ListingsControlsOptions/types';
import * as styles from './ActiveFacets.styles';

interface ActiveFacetsProps {
  activeFacets: Facet[];
  onResetFacet: (resetFacetDetails: ChangedFacetDetails) => void;
  onResetFacets: () => void;
}

export const ActiveFacets = ({ activeFacets, onResetFacet, onResetFacets }: ActiveFacetsProps) => {
  const activeFacetOptions = activeFacets.reduce((acc, facet) => {
    facet.options.forEach((option) => {
      if (option.active) {
        acc.push({ facet, option });
      }
    });

    return acc;
  }, [] as { facet: Facet; option: FacetOption }[]);

  const handleFacetReset = (facet: Facet, option: FacetOption) => {
    onResetFacet({
      title: facet.title,
      key: facet.key,
      options: [
        {
          ...option,
          active: false,
        },
      ],
    });
  };

  if (activeFacets.length === 0) {
    return null;
  }

  return (
    <ul css={styles.list}>
      {activeFacetOptions.map(({ facet, option }) => (
        <li key={`${facet.key}-${option.value}`}>
          <button
            aria-label={`Clear the "${option.title}" filter`}
            css={styles.resetFacetButton}
            onClick={() => handleFacetReset(facet, option)}
            type="button"
          >
            {option.title} <IconClose color="var(--brand-purple-base)" />
          </button>
        </li>
      ))}
      <li>
        <button
          aria-label="Clear all filters"
          css={styles.resetAllButton}
          onClick={onResetFacets}
          type="button"
        >
          Clear all
        </button>
      </li>
    </ul>
  );
};
